import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import type { Sakstype } from '@es/shared';
import { Saksside } from '../sak/Saksside.js';

/**
 * En sak i Enklere styring: et aksjonspunkt fra et møte, eller et tiltak.
 * Avvikene og kontrollene har sin side i vedlikeholdsappen.
 */
export function Sak({ typer }: { readonly typer: readonly Sakstype[] }): ReactElement {
  const { type = '', id = '' } = useParams();
  const sakstype = typer.find((t) => t === type);
  if (sakstype === undefined) {
    return (
      <>
        <h1 className="text-xl font-semibold text-tekst">Siden finnes ikke</h1>
        <p className="mt-2 text-sm text-tekst-dempet">
          Saken finnes ikke, eller modulen er ikke aktivert for kommunen din.
        </p>
      </>
    );
  }
  return (
    <Saksside
      key={`${sakstype}-${id}`}
      type={sakstype}
      id={id}
      tilbake={
        sakstype === 'aksjonspunkt'
          ? { til: '/moter', tekst: 'Møter og grupper' }
          : { til: '/kpi', tekst: 'KPI og tiltak' }
      }
    />
  );
}
